import styled from 'styled-components';
import Popup from 'reactjs-popup';
import { detailsBackground, outlineGray } from '../../config/colors';

export const StyledPopup = styled(Popup)`
  &-overlay {
  }
  &-content {
    background-color: ${detailsBackground};
    border: 1px solid ${outlineGray};
    width: auto !important;
  }
  &-arrow {
    color: ${detailsBackground};
    border-color: ${outlineGray};
  }
`;
